import Duck from "@/components/common/3D/Duck";
import { PerspectiveCamera } from "@react-three/drei";
import { Canvas } from "@react-three/fiber";

import styles from "./CommonDuckScene.module.scss";
import { degToRad } from "three/src/math/MathUtils";

interface ICommonDuckScene {
  interactuableAnimations?: boolean;
}

const CommonDuckScene = ({
  interactuableAnimations = true,
}: ICommonDuckScene) => {
  return (
    <div className={styles.sceneDuck}>
      <Canvas style={{ width: "100%", height: "100%" }}>
        <PerspectiveCamera position={[0, 0, 10]} fov={30} makeDefault />
        <group position={[0, 0, 0]} rotation={[0, 0, 0]} scale={4}>
          <Duck
            position={[0, -0.5, 0]}
            rotation={[0, degToRad(-30), 0]}
            scale={1.25}
            interactuableAnimations={interactuableAnimations}
            cursorAnimations
            cursorAngleLimit={15}
          />
        </group>
      </Canvas>
    </div>
  );
};

export default CommonDuckScene;

CommonDuckScene.displayName = "CommonDuckScene";
